const cnpj = cnpj => {
  let match = cnpj.match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
  return (
    [match[1], match[2], match[3]].join(".") + "/" + match[4] + "-" + match[5]
  );
};

const currency = value => {
  return new Intl.NumberFormat("pt-BR", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "BRL"
  }).format(value);
};

export const maskData = {
  cnpj,
  currency
};
